import { useQuery } from '@tanstack/react-query';
import { customFetcher } from '../useFetch';
import { ILegalClientInvite } from '../../Interfaces/ILegalClientInvite';

//////////////////// LegalTransactionFullObject
export const useGetInvitedByLegalTransaction = (
  idLegalTransaction?: number
) => {
  const {
    data: invites,
    isFetching: isFetchingInvites,
    refetch: refetchInvites,
  } = useQuery<ILegalClientInvite[]>({
    refetchOnWindowFocus: false,
    queryKey: ['legalclientinvite/getByIdLegalTransaction', idLegalTransaction],
    queryFn: () =>
      customFetcher({
        endpoint: `/legalclientinvite/getByIdLegalTransaction/${idLegalTransaction}`,
      }),
    enabled: !!idLegalTransaction,
  });

  return {
    invites,
    isFetchingInvites,
    refetchInvites,
  };
};
